import { FaceTimeWork } from "../../services/face-Time-Work/faceTimeWork.model";
import { WvSimpleSpotFile } from '../spots/model/wFile';
import { MagicInfoPowerStatus } from "./park/park.component";

/**
 * Output de l'appel à `screenLocations/getFace`
 */
export interface GetFaceOutput {
    clients: ClientFaces[];
    wancoms: WancomFaces[];
}

export interface ClientFaces {
    /**
     * Faces de l'organisation
     */
    faces: ClientFaceDetail[];
    /**
     * Nom de l'orga
     */
    organizationName: string;
}

export interface FaceDetail {

    /**
     * Adresse de la face
     */
    address: string;
    /**
     * Id de la face
     */
    faceId: number;
    /**
     * Nom de la face
     */
    name: string;
    /**
     * Code écran
     */
    screenCode: string;
    /**
     * Id du fichier S3
     */
    storageId: string;
    /**
     * Liste des tags associés à la face
     */
    tags: { tagId: number; name: string }[];
    /**
     * Id de la miniature du fichier S3
     */
    thumbnailStorageId: string;
    /**
     * Liste des horaires d'allumage/arrêt de la face
     */
    timeWorks: FaceTimeWork[];
    /**
     * Code postal de la face
     */
    zipCode: number;
    /**
     * formatTypeId Id du format
     */
    formatTypeId: number;

    /**
     * statu d'allumage de la Tv
     */
    powerStatus_MagicInfo?: MagicInfoPowerStatus;

    /**
     * True si la face est relié à MagicInfo (est une TV)
     */
    isMagicInfo?: boolean;

    pixelWidth: number;
    pixelHeight: number;
    lat: any;
    lon: any;
}

export interface WancomFaces extends FaceDetail {
    /**
     * Liste de campagne Wancom sur la face
     */
    campaigns: WancomCampaign[];
}

export interface ClientFaceDetail extends FaceDetail {
    /**
     * Liste des diffusions sur la face
     */
    diffusions: ClientFaceDiffusion[];
}

export function toWancomFace(face: FaceDetail): WancomFaces {
    if (getSubClassName(face) === 'Wancom') {
        return face as WancomFaces;
    }
}

export function toClientFace(face: FaceDetail): ClientFaceDetail {
    if (getSubClassName(face) === 'Client') {
        return face as ClientFaceDetail;
    }
}

export function getSubClassName(faceDetail: FaceDetail): 'Wancom' | 'Client' | 'Unknown' {
    if ((faceDetail as WancomFaces)?.campaigns != null) {
        return 'Wancom';
    } else if ((faceDetail as ClientFaceDetail)?.diffusions != null) {
        return 'Client';
    } else {
        return 'Unknown';
    }
}

export interface WancomCampaign {
    /**
     * Id de la campagne Wancom
     */
    campaignId: number;
    /**
     * Dates de la campagnes
     */
    date: WancomCampaignDate;
    /**
     * Diffusions de la campagne Wancom
     */
    diffusions: FaceDiffusion[];
    /**
     * Nom de la campagne
     */
    name: string;
    /**
     * Type d'OrderForm
     * - 0 : BDC
     * - 1 : FA
     */
    orderType: number;
    /**
     * Numéro de commande de la campagne Wancom
     */
    orderFormNumber?: string;
    orderFormId?: number;
    orderFormDownloadCode?: string;
    /**
     * Durée disponible sur la campagne en seconde
     */
    duration?: number;

    isHighlight?: number;
}

export interface WancomCampaignDate {
    /**
     * Date de fin de la campagne Wancom
     */
    end: Date;
    /**
     * La diffusion est-elle en train de diffusion ?
     */
    isCurrent: boolean;
    /**
     * La diffusion est ancienne ?
     */
    isOld: boolean;
    /**
     * Date de début de la campagne Wancom
     */
    start: Date;
}

export interface FaceDiffusion {
    isPermanent?: boolean;
    /**
     * Id de la diffusion
     */
    diffusionId: number;
    /**
     * Date de fin de la diffusion
     */
    endDate: any;
    /**
     * Nom de la diffusion
     */
    name: string;
    /**
     * Liste des spot de la diffusion
     */
    spots: DiffusionSpot[];
    /**
     * Date de début de la diffusion
     */
    startDate: any;
    /**
     * Liste des déclancheurs de la diffusion
     */
    trigger: DiffusionTriggers;
    /**
     * Si il s'agit de la diffusion par default
     */
    isDefault: boolean;

    /**
     * Nombre d'autres écrans dans lequel la diffusion joue
     */
    otherScreens: number;

    diffusionPriority: number;

    isHighlight: number;
}

export interface ClientFaceDiffusion extends FaceDiffusion {
    /**
     * Id de la campagne
     */
    campaignId: number;
    /**
     * La diffusion est-elle en train de diffusion ?
     */
    isCurrent: boolean;
    /**
     * La diffusion est ancienne ?
     */
    isOld: boolean;

    /**
     * La Diffusion/réservation est permanente ?
     * `true` si on affiche pas de date de fin
     */
    isPermanent: boolean;
}

export interface DiffusionSpot {

    /**
     * Fichier du spot
     */
    file?: WvSimpleSpotFile;

    /**
     * Ordre de diffusion du spot dans la boucle
     */
    loopOrder: string;
    /**
     * Moderation en attente
     */
    moderationFile: SpotModerationFile[];
    /**
     * Nom du spot
     */
    name: string;
    /**
     * Id du spot
     */
    spotId: number;
    /**
     * Template reference spotID
     */
    templateRefenceId?: number;

    /**
     * externalDatas
     */
    externalDatas?: any;
    
    isHighlight: number;
}

export interface SpotModerationFile extends WvSimpleSpotFile {
    id: number;
}

export interface DiffusionTriggers {
paramTemp: any;
paramTempCondition: any;
    /**
     * Jours de diffusions
     *
     * Tableau de `dayOfWeeks`
     */
    diffusionDay: DayOfWeek[];
    /**
     * Température maximale de diffusion
     */
    maxTemp?: number;
    /**
     * Température minimale de diffusion
     */
    minTemp?: number;
    /**
     * Heure de fin de diffusion
     */
    paramEndHour?: string;
    /**
     * Heure de fdébut de diffusion
     */
    paramStartHour?: string;
    /**
     * Paramètre météo de diffusion
     *
     * > Voir weather.model.ts
     */
    paramWeather?: number;
}

export enum DayOfWeek {
    Lundi = 1,
    Mardi = 2,
    Mercredi = 3,
    Jeudi = 4,
    Vendredi = 5,
    Samedi = 6,
    Dimanche = 7,
}

export enum DayOfWeekFlags {
    Lundi = 1,
    Mardi = 2,
    Mercredi = 4,
    Jeudi = 8,
    Vendredi = 16,
    'Lun-Ven' = 31,
    Samedi = 32,
    Dimanche = 64,
    'Lun-Sam' = 63,
    'Week-End' = 96,
    Semaine = 127,
}
